<template>
  <JazelAppContainer
    app-name="Micro SRP"
    @update:account-settings="accountSettings.setAccountSettings($event)"
    @update:session-token="accountSettings.setSessionToken($event)"
    @update:is-client-user="accountSettings.setIsClientUser($event)"
    @update:user-role="accountSettings.setRole($event)"
    @update:product-settings="productSettings.setProductSettings($event)"
  >
    <Dashboard />
  </JazelAppContainer>
</template>

<script setup lang="ts">
import Dashboard from '@/components/Dashboard.vue'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import { useProductSettingsStore } from '@/stores/productSettings'
import { JazelAppContainer } from '@jazel/jazel-vuetify'

const accountSettings = useAccountSettingsStore()
const productSettings = useProductSettingsStore()
</script>
